export default __webpack_public_path__ + "static/media/search-icon.b912bb9a.svg";